<template>
    <v-navigation-drawer app v-model="drawer" 
        :permanent="!isMobile"
        class="secondary" clipped floating>
        <v-layout column fill-height>
            <div style="height:160px;background:#209ecc;">
                <img :src="require('@/assets/icon.png')" style="height:100px!important;display:block;margin:auto;margin-top:30px;">
            </div>
            <v-list>
                <v-list-tile v-for="item in items" :key="item.title" :to="{path: item.path}">
                    <v-list-tile-action>
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title v-text="$t('views.'+item.title)"></v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
            </v-list>
            <v-spacer></v-spacer>
        </v-layout>
    </v-navigation-drawer>
</template>

<script>
export default {
    name: 'Drawer',
    data: function(){
        return{
            currentDate:null,
            dialog:false,
        };
    },
    computed: {
        info () {
            return this.$store.state.app.title + ' v' + this.$store.state.app.version
        },
        drawer: {
            get () {
                return this.$store.state.app.drawer
            },
            set (val) {
                this.$store.commit('drawer', val)
            }
        },
        items () {
            let vm = this;
            let list = [];
            vm.$router.options.routes.forEach(route => {
                if (vm.$store.state.auth.token && route.meta.secure && route.meta.main) {
                    list.push({
                        title: route.meta.title,
                        icon: route.meta.icon,
                        path: route.path
                    })
                } else if (!vm.$store.state.auth.token && !route.meta.secure && route.meta.main) {
                    list.push({
                        title: route.meta.title,
                        icon: route.meta.icon,
                        path: route.path
                    })
                }
            })
            return list;
        }
    },
    mounted:function(){
        let vm=this;
        vm.currentDate = new Date();
        setInterval(function(){
            vm.currentDate = new Date();
        },10000);
    }
}
</script>

<style>
    i.v-icon.material-icons.theme--light {
        max-width: 25px;
    }
    .v-navigation-drawer a{
        color:black;
        text-decoration: none;
    }
</style>